import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KModalHeader";
var classes = {
    title: "".concat(PREFIX, "-title"),
    fullscreen: "".concat(PREFIX, "-fullscreen"),
    close: "".concat(PREFIX, "-close")
};
var StyledKModalHeader = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: theme.palette.grey[200],
            display: "flex"
        },
        _b["& .".concat(classes.title)] = {
            fontWeight: "bold",
            color: theme.palette.grey[900],
            hyphens: "auto",
            wordBreak: "normal",
            padding: theme.spacing(1, 2),
            flexGrow: 1
        },
        _b["& .".concat(classes.fullscreen)] = {
            color: theme.palette.text.primary,
            fontWeight: "bold",
            textTransform: "uppercase",
            padding: theme.spacing(1),
            fontSize: ".8rem",
            flexShrink: 0
        },
        _b["& .".concat(classes.close)] = {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.grey[300],
            fontWeight: "bold",
            textTransform: "uppercase",
            padding: theme.spacing(1),
            fontSize: ".8rem",
            flexShrink: 0
        },
        _b);
});

export { classes, StyledKModalHeader as default };
//# sourceMappingURL=index.styled.js.map
